import { render, staticRenderFns } from "./image-element.vue?vue&type=template&id=6306e18b&scoped=true&"
import script from "./image-element.vue?vue&type=script&lang=js&"
export * from "./image-element.vue?vue&type=script&lang=js&"
import style0 from "./image-element.vue?vue&type=style&index=0&id=6306e18b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6306e18b",
  null
  
)

export default component.exports